module.exports = __webpack_public_path__ + "media/images/users-a9e6c14a25523f679cb0ef58f2a98e06.svg";